module.exports = __webpack_public_path__ + "img/skip-forward.51fefddf.svg";